/**
 * Formats a Date object to ISO date string (YYYY-MM-DD) using local date components.
 *
 * The calendar day is the one the *executing process* is in, so the same instant yields different
 * strings in different timezones. That is what a browser caller wants — the day the user sees — and
 * why the frontend date inputs use it. Server callers get UTC only because every backend surface is
 * pinned to it; code that needs a specific zone must say so rather than rely on that.
 * @util
 * @param date - The date to format
 * @returns ISO date string in YYYY-MM-DD format
 * @__NO_SIDE_EFFECTS__
 */
export function formatDateIso(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
//# sourceMappingURL=formatDateIso.js.map